import { render, staticRenderFns } from "./EditarProcedimiento.vue?vue&type=template&id=ab0d023c&"
import script from "./EditarProcedimiento.vue?vue&type=script&lang=js&"
export * from "./EditarProcedimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports